<template>
  <div class="animated fadeIn vld-parent custom-100" >
  <iframe src="https://bisoffice.net" />
  </div>
</template>

<script>
export default {
  name: "iframe_test"
}
</script>

<style scoped>

</style>
